import dayjs from 'dayjs'
import { useMemo } from 'react'
import { DailyStatsType } from './Stats'

// eslint-disable-next-line no-unused-vars
const mockstats = {
  '02-05-2023': {
    score: 7,
    kuran: 4,
  },
  '03-05-2023': {
    score: 6,
    kuran: 3,
  },
  '04-05-2023': {
    score: 8,
    kuran: 5,
  },
  '05-05-2023': {
    score: 0,
    kuran: 2,
  },
  '06-05-2023': {
    score: 0,
    kuran: 4,
  },
  '07-05-2023': {
    score: 0,
    kuran: 3,
  },
  '08-05-2023': {
    score: 0,
    kuran: 5,
  },
}

const getPositiveRandomMessage = (streak: number) => {
  const messages = [
    `Bugün ${streak} günlük hayır zinciri oluşturdun! 🥳🎉`,
    `${streak} günlük hayır zinciri oluşturdun! 🎉`,
    `Son ${streak} gündür devam ediyorsun! 🚀💯`,
    `Her gün biraz daha ilerliyorsun! 🚀💯`,
    `Helal olsun! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Maşallah! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Mükemmel! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Harika! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Süper! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `${streak} günlük düzenli maneviyat! 🚀💯`,
    `Hedefe doğru ilerliyorsun! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Bu şekilde devam et! 🚀💯 ${streak} gündür devam ediyorsun!`,
    `Göz kamaştırıcı bir başarı! 🌟 ${streak} günlük serinin tadını çıkar!`,
    `${streak} günlük zafer serisi! 🏆 Tebrikler!`,
    `Devam ettiğin her gün bir başarı hikayesi! 📚 ${streak} gün oldu!`,
    `İnanılmaz bir disiplin gösteriyorsun! 💪 ${streak} gündür hiç aksatmadın!`,
    `Bu ${streak} günlük yolculukta her adımın değerli!`,
    `Allah sebatını arttırsın! ${streak} gündür devam etmek kolay değil!`,
    `Her gün yeni bir sayfa, her gün yeni bir kazanım! ${streak} gün oldu!`,
  ]

  return messages[Math.floor(Math.random() * messages.length)]
}

const getPositiveAndSupportiveRandomMessage = (streak: number) => {
  const messages = [
    `Bugün de devam ederek ${streak} günlük zinciri kırma! 💪🏼`,
    `${streak} günlük zinciri kırma! Bugün de devam et! 💪🏼`,
    `${streak} gündür devam ediyorsun! Bugün de devam et! 💪🏼`,
    `Bugün de devam et! 💪🏼 ${streak} gündür devam ediyorsun!`,
    `Hadi zinciri kırma! Bugün de devam et! 💪🏼`,
    `Tam ${streak} gündür devam ediyorsun! Bozma! 💪🏼`,
    `Allah'ın en sevdiği amel devamlı olanıdır!`,
    `Çok iyi gidiyorsun! Bugün de devam et! 💪🏼`,
    `Hoşgeldin! Hadi kaldığın yerden devam et! 💪🏼`,
    `Şeytan köşeden seni izliyor! ${streak} günlük zinciri kırma! 💪🏼`,
    `Bugün küçük bir adım, yarın büyük bir fark! Devam et! 🌱`,
    `${streak} günü boşa harcama, bugün de ekle! 📈`,
    `Zincirin gücü tüm halkaların birleşmesiyle ortaya çıkar! Bugün de ekle! ⛓️`,
    `Biraz yorgun olabilirsin ama vazgeçme! ${streak} günlük zinciri kırma! 🔥`,
    `Unutma, en karanlık geceden sonra bile güneş doğar! Bugün de devam et! 🌅`,
    `Her başarı hikayesi "bugün de yapacağım" diyerek yazılır! ${streak} günü koru! 📝`,
  ]

  return messages[Math.floor(Math.random() * messages.length)]
}

const getNegativeRandomMessage = (streak: number) => {
  const messages = [
    `Neredesin? 🤔 Uzun zaman oldu!`,
    `Neredesin? 🤔 ${streak} gündür devam etmiyorsun!`,
    `${streak} gündür devam etmiyorsun! 😞`,
    `Seni özledik! 😞 ${streak} gündür devam etmiyorsun!`,
    `Unuttun mu? 😞 ${streak} gündür devam etmiyorsun!`,
    `Bildirimlerin kapalı mı? 😞 ${streak} gündür devam etmiyorsun!`,
    `Bir aydan fazla oldu! Neredesin? 😞`,
    `Uzuuuuuun zaman oldu! Neredesin? 😞`,
    `Hayır zincirine geri dönme vakti geldi! Özledik seni! 💌`,
    `Her zaman yeniden başlama şansın var! Bugün başla! 🌟`,
    `Seni bekleyen sayfalar var! Hadi geri dön! 📚`,
    `Geçmiş geride kaldı! Şimdi yeni bir başlangıç yapma zamanı! ⏰`,
  ]

  return messages[Math.floor(Math.random() * messages.length)]
}

// eslint-disable-next-line no-unused-vars
const getRecoveryMessage = (streak: number) => {
  const messages = [
    `Harika - zincir kurtarıldı! ${streak} günlük seriye devam ediyorsun! 🔄✨`,
    `Bir günlük ara vermişsin ama sorun değil! ${streak} günlük serine devam! 🧠`,
    `Zincir kopmadı, sadece esnedi! ${streak} günlük başarı devam ediyor! 💪`,
    `Bir gün ara vermek bazen gereklidir! ${streak} günlük serin devam ediyor! 🌱`,
    `Küçük molalar büyük dönüşleri getirir! ${streak} günlük seriye tekrar hoşgeldin! 🚀`,
    `Düştüğün yerden kalkmışsın! ${streak} günlük serinin devamını getir! 🏆`,
  ]

  return messages[Math.floor(Math.random() * messages.length)]
}

const getTheUserStreakStatus = (
  dailyStats: DailyStatsType,
): { streak: number; text: string } => {
  let streak = 0
  let currentDay = dayjs()
  let hadGapYesterday = false
  let continuousStreak = true

  // Check for streak with possible multiple gap days (but not consecutive)
  while (continuousStreak) {
    const formattedCurrentDay = currentDay.format('DD-MM-YYYY')
    const yesterdayKey = currentDay.subtract(1, 'day').format('DD-MM-YYYY')
    const dayBeforeYesterdayKey = currentDay.subtract(2, 'day').format('DD-MM-YYYY')

    // Check if current day has activity
    if (dailyStats[formattedCurrentDay]?.score > 0) {
      streak++
      hadGapYesterday = false
      currentDay = currentDay.subtract(1, 'day')
    }
    // Check for one gap day
    else if (!hadGapYesterday && dailyStats[yesterdayKey]?.score > 0) {
      streak++
      hadGapYesterday = false
      currentDay = currentDay.subtract(1, 'day')
    }
    // Allow skipping one day if the day before that had activity
    else if (!hadGapYesterday && dailyStats[dayBeforeYesterdayKey]?.score > 0) {
      // We found a gap day, but there is activity the day before the gap
      hadGapYesterday = true
      streak++
      currentDay = currentDay.subtract(2, 'day')
    }
    // We had a gap yesterday and today is also a gap - this breaks the streak
    else if (hadGapYesterday) {
      continuousStreak = false
    }
    // No recent activity found - break the streak
    else {
      continuousStreak = false
    }
  }

  const today = dayjs().format('DD-MM-YYYY')

  // If today already has activity, don't count it again as it's already included in the streak calculation
  const hasActivityToday = dailyStats[today]?.score > 0

  // if the user was active until yesterday but not today
  if (!hasActivityToday && streak > 0) {
    return {
      streak,
      text: getPositiveAndSupportiveRandomMessage(streak),
    }
  }

  // If the user has a streak (which now includes today if they were active)
  if (streak > 0) {
    return {
      streak,
      text: getPositiveRandomMessage(streak),
    }
  }

  // check how many days ago the user was active last time
  let lastActiveDay = dayjs()
  let foundActiveDay = false

  while (!foundActiveDay && lastActiveDay.diff(dayjs().subtract(70, 'day'), 'day') > 0) {
    const checkDay = lastActiveDay.subtract(1, 'day').format('DD-MM-YYYY')
    if (dailyStats[checkDay]?.score > 0) {
      foundActiveDay = true
    } else {
      lastActiveDay = lastActiveDay.subtract(1, 'day')
    }
  }

  const daysAgo = foundActiveDay ? dayjs().diff(lastActiveDay, 'day') : 0

  if (daysAgo === 2) {
    return {
      streak: 0,
      text: '2 gündür devam etmiyorsun! Ama hala telafi edebilirsin.',
    }
  }

  if (daysAgo === 3) {
    return {
      streak: 0,
      text: '3 gündür yoksun ☹️ İyi gidiyordu aslında 😞',
    }
  }

  if (daysAgo > 3 && daysAgo < 25) {
    return {
      streak: 0,
      text: `${daysAgo} gündür yoksun ☹️ Seni özledik! Hadi geri dön!`,
    }
  }

  const isThereAnyActiveDay = Object.keys(dailyStats).some(
    (day) => dailyStats[day]?.score > 0,
  )

  if (daysAgo > 25 && isThereAnyActiveDay) {
    return {
      streak: 0,
      text: getNegativeRandomMessage(daysAgo),
    }
  }

  return {
    streak: 0,
    text: `Hemen bir şeyler okuyarak kendi hayır zincirini başlat! 💪🏼`,
  }
}

const StatsStreakStatus = ({ dailyStats }: { dailyStats: DailyStatsType }) => {
  const streakStatus = useMemo(() => getTheUserStreakStatus(dailyStats), [dailyStats])

  return (
    <div className="mt-4">
      <p className="rounded-lg bg-warning-subtle p-2 text-sm font-medium text-main border border-warning/10 transition-all duration-300">
        {streakStatus.text}
      </p>
    </div>
  )
}

export default StatsStreakStatus
